import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const LOGO = "/assets/brand/logo-traiteur-fl-blanc.webp";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-ink-800 mt-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <img src={LOGO} alt="Traiteur FL" className="logo-adaptive h-12 w-auto mb-4" />
          <p className="text-muted-foreground text-sm leading-relaxed font-body">
            Cuisine authentique et faite maison au cœur de Portneuf <span className="text-coral font-accent italic">depuis 1978</span>.
          </p>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-foreground mb-4 text-sm uppercase tracking-wider">Navigation</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/" className="hover:text-coral transition-colors">Accueil</Link></li>
            <li><Link to="/menu" className="hover:text-coral transition-colors">Nos menus</Link></li>
            <li><Link to="/a-propos" className="hover:text-coral transition-colors">À propos</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-foreground mb-4 text-sm uppercase tracking-wider">Coordonnées</h4>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex gap-2.5"><MapPin className="h-4 w-4 text-coral shrink-0 mt-0.5" /> 374 Saint Joseph,<br />St-Raymond, QC G3L 1J9</li>
            <li className="flex gap-2.5"><Phone className="h-4 w-4 text-coral shrink-0" /> (418) 987-8317</li>
            <li className="flex gap-2.5"><Mail className="h-4 w-4 text-coral shrink-0" /> Info@traiteurfl.com</li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-foreground mb-4 text-sm uppercase tracking-wider">Horaires</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li className="flex gap-2.5"><Clock className="h-4 w-4 text-coral shrink-0 mt-0.5" /><div><strong className="text-foreground">Lundi</strong> : 8h00 - 17h30</div></li>
            <li className="pl-6"><strong className="text-foreground">Mardi au vendredi</strong> : 8h00 - 14h00</li>
            <li className="pl-6">Samedi et dimanche : fermé<br /><span className="text-xs">(exception pour les traiteurs)</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-6 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Traiteur FL — Francine Lesage Traiteur. Tous droits réservés.
      </div>
    </footer>
  );
}
